import type { IconData } from '@stacksjs/iconify-core'

export const tab: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18 4v1h-7V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM4 0h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export default tab
